import { useState, type PointerEvent } from "react";

const IRIS_CENTER = "50% 50%";

/** Tap point of a selectable card as a CSS position (`origin`) and the capture handler that records it; the center until the first tap (keyboard). */
export function useSelectionIrisOrigin() {
  const [origin, setOrigin] = useState(IRIS_CENTER);
  function onPointerDownCapture(event: PointerEvent<HTMLElement>): void {
    const rect = event.currentTarget.getBoundingClientRect();
    setOrigin(`${Math.round(event.clientX - rect.left)}px ${Math.round(event.clientY - rect.top)}px`);
  }
  return { origin, onPointerDownCapture };
}
